/**
 * Footer Selector Component
 * 
 * This component acts as a router/selector for different footer variants.
 * It allows the project to use multiple footer components and switch between them
 * via configuration.
 * 
 * Usage:
 * Configure in config.settings.footerVariant:
 * - 'default' (or undefined): Uses FooterDefault component
 * - 'compact': Uses FooterCompact component (when implemented)
 * - 'minimal': Uses FooterMinimal component (when implemented)
 * 
 * Example in index.js:
 * config.settings.footerVariant = 'default';
 */

import React from 'react';
import config from '@plone/volto/registry';
import { FooterDefault } from '../../../../components/Molecules/Footer';

// Import other footer variants here as they are created
// import { FooterCompact } from '../../../../components/Molecules/Footer';
// import { FooterMinimal } from '../../../../components/Molecules/Footer';

const Footer = () => {
  const { settings } = config;
  const footerVariant = settings.footerVariant || 'default';

  // Footer variant selector
  const footerComponents = {
    default: FooterDefault,
    // compact: FooterCompact,  // Uncomment when implemented
    // minimal: FooterMinimal,  // Uncomment when implemented
  };

  const SelectedFooter = footerComponents[footerVariant] || FooterDefault;

  return <SelectedFooter />;
};

export default Footer;
